import { createAction, handleActions } from "redux-actions";

const defaultState = {
  networkState: true,
}

const SET_NETWORK_STATE = 'network/SET_NETWORK_STATE';

export const setNetworkState = createAction(SET_NETWORK_STATE, (data) => data);

const network = handleActions(
  {
    [SET_NETWORK_STATE]: (state, { payload: data }) => {
      return data;
    }
  },
  defaultState
)

export default network;